// number of cars downloaded at once
export const CARS_LIMIT = 15;
// min number of vehicles for comparison to be available
export const MIN_VEHICLES_TO_COMPARE = 2;
// max number of vehicles to compare
export const VEHICLE_COMPARE_LIMIT = 10;
export const DEFAULT_GROUPED_INFO = {
    fuel: [],
    doors: [],
    series: [],
    vehicleTypeName: []
};
// export const DEFAULT_USER_INPUT_DATA: IUserInputData = {
//   make: null,
//   model: null,
//   month: null,
//   year: null,
//   fuel: null,
//   vehicle_type_name: null,
//   seats: null,
//   series: null
// };
export const CYLINDERS = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]; // eslint-disable-line
export const KEYBOARD_BUTTONS = {
    LEFT_ARROW: 37,
    RIGHT_ARROW: 39,
    ESC: 27
};
